// Warum lud die Seite neu? (Tim 20.10.2026: „Das Homelab lädt periodisch
// die Seite neu … ohne die Meldung einfach so. Was ist da los?")
//
// Von außen sieht man nur, DASS der Browser die Seite neu holte. Darum:
// jedes Neuladen, das das Homelab selbst auslöst, geht über ladeNeu(grund)
// und hinterlegt den Grund in sessionStorage. Beim nächsten Start meldet
// meldeStart() dem Server (nur ins Protokoll, internal/api/neuladen.go),
// wie die Seite kam:
//   grund "version" | "baustein" | "anmeldung" | "knopf" | …  -- wir selbst
//   grund "abgestürzt"  -- die vorige Seite endete ohne pagehide (der
//                          Browser hat sie beendet: Speicher, Absturz)
//   grund "browser"     -- als Neuladen gekommen, ohne unseren Grund
//                          (Knopf in Safari, Tastenkürzel)
// Gewöhnliche Starts (Adresse, Lesezeichen) meldet sie nicht.

import { postJSON } from "./api";

const GRUND = "neuladen-grund";
const LEBT = "seite-lebt";
const START = "seite-start";
const DETAIL = "neuladen-detail";

function lies(k: string): string | null {
  try {
    return sessionStorage.getItem(k);
  } catch {
    return null;
  }
}
function schreib(k: string, v: string | null): void {
  try {
    if (v === null) sessionStorage.removeItem(k);
    else sessionStorage.setItem(k, v);
  } catch {
    /* Privatmodus o. ä. */
  }
}

/** Die Seite neu laden und den Grund für den nächsten Start hinterlegen
 *  (detail: was genau, z. B. der Baustein, der nicht lud). */
export function ladeNeu(grund: string, detail = ""): void {
  schreib(GRUND, grund);
  schreib(DETAIL, detail.slice(0, 300));
  schreib(LEBT, null);
  window.location.reload();
}

/** Was die Seite gerade tut. Stürzt sie ab, nennt der nächste Start
 *  (meldeStart) diesen Schritt als detail -- SolidCraft im eigenen Tab
 *  stürzte in Safari ab, nachstellen lässt es sich hier nicht (Tim
 *  24.10.2026). */
export function merkeSchritt(text: string): void {
  schreib(DETAIL, text.slice(0, 300));
}

/** Beim Start einmal: melden, wie die Seite kam, und ab jetzt merken,
 *  dass sie lebt (pagehide räumt es ab). */
export function meldeStart(): void {
  const nav = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;
  const art = nav?.type ?? "";
  const unser = lies(GRUND);
  const detail = lies(DETAIL) ?? "";
  schreib(DETAIL, null);
  const starb = lies(LEBT) === "1";
  const vorher = Number(lies(START) || 0);
  schreib(GRUND, null);
  schreib(LEBT, "1");
  schreib(START, String(Date.now()));
  window.addEventListener("pagehide", () => schreib(LEBT, null));
  // bfcache: kommt die Seite aus dem Speicher zurück, lebt sie wieder.
  window.addEventListener("pageshow", () => schreib(LEBT, "1"));

  const grund = unser ?? (starb ? "abgestürzt" : art === "reload" ? "browser" : "");
  if (!grund) return;
  void postJSON("/v2-api/client/neuladen", {
    grund,
    detail,
    art,
    lebte_s: vorher ? Math.round((Date.now() - vorher) / 1000) : 0,
    sichtbar: document.visibilityState,
    pfad: location.pathname,
  }).catch(() => {});
}
